import { ThemedText, ThemedView } from '@app/theme'
import CamsLogo from '@app/assets/svg/CamsLogo'
import KfinLogo from '@app/assets/svg/KfinLogo'
import { firebase } from '@react-native-firebase/remote-config'
import { useAppSelector } from '@app/store/hooks'


const PledgePoweredBy = () => {
  const firebaseParams = useAppSelector((state) => state.firebaseParams);
  const {is_mfc_up} = firebaseParams;
  return (
    <ThemedView borderWidth={1} borderColor='border-primary' borderRadius='xs' alignSelf='center' flexDirection='row' justifyContent='center' alignItems='center'>
        <ThemedView borderRightWidth={1} borderColor='border-primary' paddingVertical='xs' paddingHorizontal='sm'>
            <ThemedText variant='b5r' color='text-secondary'>Powered by</ThemedText>
        </ThemedView>
        <ThemedView borderLeftWidth={0} borderRightWidth={1} borderColor='border-primary' paddingVertical='xs' paddingHorizontal='sm'>
            <ThemedText variant='b3b' color='text-secondary'>MFCentral</ThemedText>
        </ThemedView>
        <ThemedView borderRightWidth={1} borderColor='border-primary' paddingVertical='xs' paddingHorizontal='sm'>
            <KfinLogo />
        </ThemedView>
        <ThemedView borderLeftWidth={0} borderRightWidth={1} borderColor='border-primary' paddingVertical='xs' paddingHorizontal='sm'>
            <CamsLogo />
        </ThemedView>
    </ThemedView>
  )
}

export default PledgePoweredBy
